<template>
  <div id="compreSportsMeet_sportsDetail" v-show="currThemeObj">
    <div class="abs_top">
      <sportsDetail_inforPanel
        :currThemeObj="currThemeObj"
        :currSportsDetail="currSportsDetail"
        :matchEventList="matchPanel_matchEventList"
        :isOpenFlag="containerCascaderMeun_isOpenFlag"
        :currSid="currSid"
        @clickIsOpenMeunEvent="clickIsOpenMeunHandler"
      ></sportsDetail_inforPanel>
      <div class="selectTab_area">
        <selectTab
          :currThemeObj="currThemeObj"
          :tabArr="tabArr"
          :pageJumpParams="selectTab_pageJumpParams"
          @clickTabEvent="onChangeTab"
        ></selectTab>
      </div>
    </div>
    <div>
      <router-view
        :axiosBaseUrl="axiosBaseUrl"
        :currThemeObj="currThemeObj"
        :currGroup="currGroup"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :isRefresh="isRefresh"
        :refreshTime="refreshTime"
        :pageJumpParams="selectTab_pageJumpParams"
        :bigSportsList="bigSportsList"
        :curTimeZoneItem="curTimeZoneItem"
        @updateCurrSportsDetail="updateCurrSportsDetailHanlder"
      ></router-view>
    </div>
    <div class="" v-show="containerCascaderMeun_isOpenFlag">
      <container_cascader_meun
        :curValArr="curValArr"
        :datas="sportsAndEventList"
        :isOpenFlag="containerCascaderMeun_isOpenFlag"
        @clickIsOpenMeunEvent="clickIsOpenMeunHandler"
        @changeSportsEventId="changeSportsEventIdHandler"
      ></container_cascader_meun>
    </div>
  </div>
</template>

<script>
import sportsDetail_inforPanel from './sportsDetail_inforPanel.vue'
import selectTab from '@components/platfromBase/compreSportsMeet/selectTab.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import container_cascader_meun from '@components/platfromBase/compreSportsMeet/container_cascader_meun.vue'
import { https_sportsList_eventList } from '@api/platfrom_compreSportsMeet_api'
export default {
  name: 'compreSportsMeet_sportsDetail',
  components: { sportsDetail_inforPanel, selectTab, container_cascader_meun },
  mixins: [cup_base_data_mixin],
  props: {
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    bigSportsList: {
      type: Array,
      default: () => {
        return []
      },
    },
    currGroup: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isRefresh: false, //是否需要实时更新
      refreshTime: 15 * 1000,
      currSportsDetail: {
        sportsId: null,
        sportsName: null,
        eventId: null,
        eventName: null,
        matchId: null,
      },
      tabArr: [
        {
          name: '赛程',
          id: ['scheduleDate', 'scheduleDetail'],
          pathName: [
            'CSMeetSportsDetailScheduleDate',
            'CSMeetSportDetailScheduleDetailStartList',
            'CSMeetSportDetailScheduleDetailLocalData',
            'CSMeetSportDetailScheduleDetailDataAnalysis',
            'CSMeetSportDetailScheduleDetailOtherTab_combinedResult',
            'CSMeetSportDetailScheduleDetailOtherTab_compreResult',
            'CSMeetSportDetailScheduleDetailOtherTab_groupResult',
            'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
            'CSMeetSportDetailScheduleDetailOtherTab_teamResult',
          ],
          act: true,
        },
        {
          name: '参赛名单',
          id: 'player',
          pathName: 'CSMeetSportsDetailPlayer',
          act: false,
        },
        {
          name: '综合成绩',
          id: 'compreScore',
          pathName: 'CSMeetSportsDetailCompreScore',
          act: false,
        },
        {
          name: '奖牌',
          id: 'medalList',
          pathName: 'CSMeetSportsDetailMedalList',
          act: false,
        },
        {
          name: '赛会数据分析',
          id: 'eventDataAnalysis',
          pathName: 'CSMeetSportsDetailEventDataAnalysis',
          act: false,
        },
      ],
      curValArr: [],
      containerCascaderMeun_isOpenFlag: false,
      selectTab_pageJumpParams: [],
      matchPanel_matchEventList: null,
      sportsAndEventList: [],
    }
  },
  created() {
    console.debug('route:', this.$route, this.currSportsDetail)
    this.tabArr = this.tabArr.map((item) => {
      if (item.pathName) {
        if (typeof item.pathName === 'string') {
          item.pathName = `${item.pathName}_${this.currCid}`
        } else if (typeof item.pathName === 'object') {
          item.pathName = item.pathName.map((pathItem) => {
            return `${pathItem}_${this.currCid}`
          })
        }
      }
      return item
    })
    const query = this.$route.query
    if (query.sportsId && query.eventId) {
      this.setCurrSportsDetail('eventId', [query.sportsId, query.eventId])
    }
    this.currSportsDetail = this.getCurrSportsDetail()
    this.selectTab_pageJumpParams = [query, this.currSportsDetail]
    console.debug('this.pageJumpParams:', this.selectTab_pageJumpParams)
    if (this.currGroup) {
      console.debug('init ')
      this.init()
    }
  },
  methods: {
    async init() {
      console.debug(this.currCid, this.currSid)
      // 获取大小项数据
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await this.getSportsAndEventList()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    changeSportsEventIdHandler(data) {
      console.debug('changeSportsEventIdHandler:', data)
      this.setCurrSportsDetail('eventId', data)
      this.updateQueryVal(data)
    },
    updateQueryVal(data, mid) {
      let query = this.$router.history.current.query
      let path = this.$router.history.current.path
      //对象的拷贝
      let newQuery = JSON.parse(JSON.stringify(query))
      // 地址栏的参数值赋值
      newQuery.sportsId = data[0]
      newQuery.eventId = data[1]
      if (mid) {
        newQuery.mid = mid
      }
      this.selectTab_pageJumpParams = [newQuery, this.currSportsDetail]
      this.$router.push({ path, query: newQuery })
    },
    updateCurrSportsDetailHanlder(data) {
      console.debug('updateCurrSportsDetail:', data, this.currSportsDetail)
      this.setCurrSportsDetail(data.state, [data.value])
      this.updateQueryVal(data, data.value)
    },
    getCurrSportsDetail() {
      return JSON.parse(
        this.$localStorage.getItem('mixtmt_platfromV4_currSportsDetail')
      )
    },
    setCurrSportsDetail(stage, valArr) {
      let currSportsDetail = {}
      let curValArr = []
      if (stage == 'sportsId') {
        let currrEventList = []
        currSportsDetail = {
          sportsId: valArr[0],
          eventId: '',
          matchId: '',
          sportsName: '',
          eventName: '',
        }
        this.sportsAndEventList.forEach((sportItem) => {
          if (sportItem.value === valArr[0]) {
            currrEventList = sportItem.children
            currSportsDetail.sportsId = valArr[0]
            currSportsDetail.sportsName = sportItem.label
            currSportsDetail.eventId = currrEventList[0].value
            currSportsDetail.eventName = currrEventList[0].label
            curValArr = [valArr[0], currrEventList[0].value]
          }
        })
        console.debug('currrEventList:', currrEventList)

        this.currrEventList = currrEventList
      } else if (stage === 'eventId') {
        let matchId = ''
        if (this.currSportsDetail.eventId === valArr[1]) {
          matchId = this.currSportsDetail.matchId
            ? this.currSportsDetail.matchId
            : ''
        }
        let currrEventList = []
        curValArr = valArr
        currSportsDetail = {
          sportsId: valArr[0],
          eventId: valArr[1],
          matchId,
          sportsName: '',
          eventName: '',
        }
        this.sportsAndEventList.forEach((sportItem) => {
          if (sportItem.value === valArr[0]) {
            currrEventList = sportItem.children
            currSportsDetail.sportsId = valArr[0]
            currSportsDetail.sportsName = sportItem.label
            currSportsDetail.eventId = valArr[1]
            currrEventList.forEach((eventItem) => {
              if (eventItem.value === valArr[1]) {
                currSportsDetail.eventName = eventItem.label
              }
            })
          }
        })
      } else if (stage === 'matchId') {
        currSportsDetail = this.getCurrSportsDetail()
        currSportsDetail.matchId = valArr[0]
        curValArr = [currSportsDetail.sportsId, currSportsDetail.eventId]
      }

      this.curValArr = curValArr
      this.currSportsDetail = currSportsDetail

      console.debug('sportsDetail_compreScore:', currSportsDetail, stage)
      this.$localStorage.setItem(
        'mixtmt_platfromV4_currSportsDetail',
        JSON.stringify(currSportsDetail)
      )
    },
    onChangeTab(item) {
      this.tabArr.forEach((tabItem) => {
        if (item.id == tabItem.id) {
          tabItem.act = true
        } else {
          tabItem.act = false
        }
      })
    },
    clickIsOpenMeunHandler(data) {
      console.debug('clickIsOpenMeunHandler:', data)
      this.containerCascaderMeun_isOpenFlag = data
    },
    async getSportsAndEventList() {
      let params = {
        sid: this.currSid,
      }
      await https_sportsList_eventList(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          console.debug('res:', res)
          if (res.status === 0) {
            this.sportsAndEventList = res.data.map((sportItem) => {
              return {
                value: sportItem.disciplineCode,
                label: sportItem.disciplineName,
                children: sportItem.events.map((event) => {
                  return {
                    value: event.eventCode,
                    label: event.eventName,
                  }
                }),
              }
            })
            console.debug('this.currSportsDetail:', this.currSportsDetail)
            if (
              this.currSportsDetail.sportsId &&
              this.currSportsDetail.eventId
            ) {
              this.setCurrSportsDetail('eventId', [
                this.currSportsDetail.sportsId,
                this.currSportsDetail.eventId,
              ])
            } else {
              this.setCurrSportsDetail('sportsId', [
                this.currSportsDetail.sportsId,
              ])
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#compreSportsMeet_sportsDetail {
  padding-top: 12.36vw;
  .abs_top {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    padding: 0 9.722vw;
    width: 100%;
    height: 12.36vw;
    color: var(--mixtmt_whiteColor);
    background-image: var(--mixtmt_scheduleDetail_banner);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    object-fit: contain;
    .selectTab_area {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 10;
      padding: 0 9.722vw;
      width: 100%;
      height: 2.778vw;
    }
  }
}
</style>
